const review = {
    NEW: "ثبت پیشنهاد/بازخورد",
    SUBMIT: "ثبت پیشنهاد/بازخورد جدید",
    TEXT: "متن نظر یا پیشنهاد",
    TEXT_NOT_VALID: "متن وارد شده باید بیشتر از ۵ حرف باشد",
}

export default review